export const pictureSet = [
    {
        mainPicture: 0,
        brille: {
            right: "80px",
            top: "0"
        },
        kittle: {
            right: "80px",
            bottom: "131px"
        },
        armel: {
            right: "20px",
            bottom: "194px"
        },
        schuhe: {
            right: "50px",
            bottom: "0"
        }
    },
    {
        mainPicture: 1,
        brille: {
            right: "80px",
            top: "0"
        },
        kittle: {
            right: "80px",
            bottom: "131px"
        },
        armel: {
            right: "20px",
            bottom: "194px"
        },
        schuhe: {
            right: "50px",
            bottom: "0"
        }
    }, {
        mainPicture: 2,
        brille: {
            right: "70px",
            top: "0"
        },
        kittle: {
            right: "70px",
            bottom: "145px"
        },
        armel: {
            right: "10px",
            bottom: "194px"
        },
        schuhe: {
            right: "40px",
            bottom: "10px"
        }
    },
    {
        mainPicture: 3,
        brille: {
            right: "80px",
            top: "0"
        },
        kittle: {
            right: "80px",
            bottom: "135px"
        },
        armel: {
            right: "10px",
            bottom: "194px"
        },
        schuhe: {
            right: "50px",
            bottom: "0px"
        }
    },
    {
        mainPicture: 4,
        brille: {
            right: "50px",
            top: "0"
        },
        kittle: {
            right: "70px",
            bottom: "150px"
        },
        armel: {
            right: "10px",
            bottom: "194px"
        },
        schuhe: {
            right: "65px",
            bottom: "0px"
        }
    },
    {
        mainPicture: 5,
        brille: {
            right: "75px",
            top: "0"
        },
        kittle: {
            right: "80px",
            bottom: "145px"
        },
        armel: {
            right: "10px",
            bottom: "194px"
        },
        schuhe: {
            right: "60px",
            bottom: "0px"
        }
    },
    {
        mainPicture: 6,
        brille: {
            right: "75px",
            top: "0"
        },
        kittle: {
            right: "80px",
            bottom: "145px"
        },
        armel: {
            right: "10px",
            bottom: "194px"
        },
        schuhe: {
            right: "76px",
            bottom: "-10px"
        }
    },
    {
        mainPicture: 7,
        brille: {
            right: "60px",
            top: "0"
        },
        kittle: {
            right: "70px",
            bottom: "135px"
        },
        armel: {
            right: "10px",
            bottom: "194px"
        },
        schuhe: {
            right: "76px",
            bottom: "-10px"
        }
    },
    {
        mainPicture: 8,
        brille: {
            right: "85px",
            top: "0"
        },
        kittle: {
            right: "85px",
            bottom: "135px"
        },
        armel: {
            right: "10px",
            bottom: "194px"
        },
        schuhe: {
            right: "46px",
            bottom: "0px"
        }
    },
    {
        mainPicture: 9,
        brille: {
            right: "75px",
            top: "0"
        },
        kittle: {
            right: "75px",
            bottom: "150px"
        },
        armel: {
            right: "10px",
            bottom: "194px"
        },
        schuhe: {
            right: "46px",
            bottom: "2px"
        }
    },
    {
        mainPicture: 10,
        brille: {
            right: "75px",
            top: "0"
        },
        kittle: {
            right: "75px",
            bottom: "150px"
        },
        armel: {
            right: "10px",
            bottom: "194px"
        },
        schuhe: {
            right: "46px",
            bottom: "2px"
        }
    },
    {
        mainPicture: 11,
        brille: {
            right: "75px",
            top: "0"
        },
        kittle: {
            right: "75px",
            bottom: "150px"
        },
        armel: {
            right: "10px",
            bottom: "194px"
        },
        schuhe: {
            right: "66px",
            bottom: "-5px"
        }
    },
    {
        mainPicture: 12,
        brille: {
            right: "75px",
            top: "0"
        },
        kittle: {
            right: "75px",
            bottom: "140px"
        },
        armel: {
            right: "10px",
            bottom: "194px"
        },
        schuhe: {
            right: "26px",
            bottom: "0px"
        }
    },
    {
        mainPicture: 13,
        brille: {
            right: "81px",
            top: "0"
        },
        kittle: {
            right: "75px",
            bottom: "140px"
        },
        armel: {
            right: "10px",
            bottom: "184px"
        },
        schuhe: {
            right: "43px",
            bottom: "0px"
        }
    },
    {
        mainPicture: 14,
        brille: {
            right: "115px",
            top: "0"
        },
        kittle: {
            right: "100px",
            bottom: "140px"
        },
        armel: {
            right: "30px",
            bottom: "184px"
        },
        schuhe: {
            right: "20px",
            bottom: "-10px"
        }
    },

    {
        mainPicture: 15,
        brille: {
            right: "45px",
            top: "0"
        },
        kittle: {
            right: "50px",
            bottom: "138px"
        },
        armel: {
            right: "0",
            bottom: "194px"
        },
        schuhe: {
            right: "76px",
            bottom: "0"
        }
    }
]